<div class="date-field">
    <ion-label *ngIf="label" stacked class="date-label" [attr.required]="required ? true : null">{{ label }}</ion-label>
    <my-date-picker #myDatePicker
                    name="duedate"
                    [placeholder]="placeholder"
                    [selDate]="default"
                    [options]="datepickerOptions"
                    (inputFieldChanged)="onInputChanged($event)"></my-date-picker>
</div>
